import { cx } from "./cx.js";

export interface QrImageProps {
  /** Inline SVG markup produced server-side by `@ohf/core` (trusted origin). */
  svg: string;
  label: string;
  size?: "sm" | "md";
}

/**
 * QR codes arrive inline in authenticated JSON (no un-authenticatable <img>
 * request), so we render the trusted SVG string directly on a white quiet zone.
 */
export function QrImage({ svg, label, size = "md" }: QrImageProps) {
  return (
    <div
      className={cx("qr-box", size === "sm" && "qr-box--sm")}
      role="img"
      aria-label={label}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
